export function scrollIntoView(element) {
  const scrollable = findScrollableParent(element);

  const rect = element.getBoundingClientRect();
  const container = scrollable.getBoundingClientRect();

  if (rect.bottom > container.bottom) {
    scrollable.scrollTop += (rect.bottom - container.bottom);
  }
}

export function scrollChildIntoView(element, selector) {
  setTimeout(() => {
    if (element) {
      scrollIntoView(element.querySelector(selector));
    }
  }, 10);
}

export function findScrollableParent(element) {
  let target = element.parentElement;
  while (target && !isScrollable(target)) {
    target = target.parentElement;
  }

  return target || document.body;
}

function isScrollable(element) {
  const style = window.getComputedStyle(element);
  const { overflow, overflowY } = style;

  return (overflow === 'auto' || overflow === 'scroll')
      || (overflowY === 'auto' || overflowY === 'scroll');
}



// WEBPACK FOOTER //
// ./src/utility/scrollIntoView.js